export const roundPercent = (num) => {
  return Math.round((num + Number.EPSILON) * 100);
};
